import React from 'react';
import { useAuth } from "../store/AuthContext";
import { callApi } from "./apiHelper";

export const useApi = () => {
  const { logout } = useAuth();

  return React.useCallback(async (url, options) => {
    return await callApi(url, options, logout);
  }, [logout]);
};


export const useHasPermission = () => {
  const { user } = useAuth();
  return (permissionKey) => {
    if (!user) {
      return false;
    }
    if (user.Role === "SuperAdmin") {
      return true;
    }

    return user.Permission?.includes(permissionKey) ?? false;
  };
};

